import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EnvelopeEditTabs } from 'src/app/enum/envelope-edit-tabs';
import { SignatoryEdit } from 'src/app/envelope/model/signatory-edit';
import { EnvelopeEditService } from 'src/app/envelope/services/envelope-edit.service';
import * as R from 'ramda';
import { SignatoryOrder } from 'src/app/envelope/model/signatory-order';
import { SignatureStatus } from 'src/app/enum/signature-status';
@Component({
  selector: 'app-edit-signatories-order',
  templateUrl: './edit-signatories-order.component.html',
  styleUrls: ['./edit-signatories-order.component.scss'],
  host: {
    '[style.display]': '"flex"',
    '[style.flex-direction]': '"column"',
    '[style.overflow]': '"hidden"'
  }
})

export class EditSignatoriesOrderComponent implements OnInit {

  @Output() closeModalClick = new EventEmitter();
  @Output() submitModalClick = new EventEmitter();

  signatories: Array<SignatoryEdit> = [];
  filteredElements: Array<SignatoryOrder> = [];
  canSave = false;
  orderChanged = false;
  orderEnabled: boolean;
  orderDisabled: boolean;
  orderMax: number;
  orderMin: number;

  constructor(
    private envelopeEditService: EnvelopeEditService) { }

  ngOnInit() {
    this.signatories = this.envelopeEditService.getModelData(EnvelopeEditTabs.Signatory).signatories;
    this.signatories.forEach(x => {
      const signatory = new SignatoryOrder();
      signatory.id = x.id;
      signatory.order = x.order;
      signatory.name = x.name;
      signatory.mail = x.mail;
      signatory.disabled = x.status !== SignatureStatus.Awaiting ? true : false;
      this.filteredElements.push(signatory);
    });

    this.filteredElements.sort((a, b) => a.order - b.order);
    this.orderEnabled = this.envelopeEditService.isOrdered;
    this.orderDisabled = this.envelopeEditService.orderDisabled;
    this.orderMax = this.maxSignatoryOrder();
    this.orderMin = this.minSignatoryOrder();
  }

  modalClose() {
    this.closeModalClick.emit();
  }

  modalSubmit() {
    this.envelopeEditService.isOrdered = this.orderEnabled;
    this.submitModalClick.emit(this.filteredElements);
  }

  processKeyPress(event) {
    if ((event.charCode <= 47)) {
      return false;
    }
  }

  processChange(i, event, element) {

    const regex : RegExp =/^\d*[1-9]\d*$/

    if(!regex.test(event.target.value)){
      event.target.value = '1';
    } else if(event.target.value > this.filteredElements.length) {
      event.target.value = this.filteredElements.length.toString();
    }

    let value = event.target.value;

    let order = parseInt(value || '1');

    let maxOrder = Math.max(...this.filteredElements.map(el => el.order), 0);

    if (maxOrder < order) {
      maxOrder = order;
    }

    this.filteredElements[i].order = order;

    for (let minOrder = 1; minOrder < maxOrder; minOrder++) {
      const existsOrder = this.filteredElements.find(x => x.order === minOrder);

      if (!existsOrder) {
        this.orderChanged = false;
        this.canSave = false;
        return;
      }
    }

    if (order > this.maxSignatoryOrder()) {
      order = this.maxSignatoryOrder();
    }

    this.filteredElements[i].order = order;
    this.filteredElements.sort((a, b) => a.order - b.order);
    this.orderChanged = true;
    this.canSave = true;
    this.orderMax = this.maxSignatoryOrder();
  }

  onChangeEnabled(event) {
    this.orderEnabled = event;
    this.canSave = this.orderChanged && event ? true : false;
  }

  maxSignatoryOrder(): number {
    const order = Math.max(...this.filteredElements.map(el => el.order), 0);
    if (order >= R.length(this.filteredElements)) {
      return R.length(this.filteredElements);
    }
    return order + 1;
  }

  minSignatoryOrder(): number {
    const filtered = this.filteredElements.filter(el => el.disabled === true);
    if (R.length(filtered) > 0) {
      const order = Math.max(...filtered.map(el => el.order), 0);
      return order + 1;
    }
    return 1;
  }
}
